// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge___22fvm","badge-text":"badge-text___3Nxk_","small":"small___142WR"};